export enum ApplicationFormStatusResponseDTO {
  NotStarted = 0,
  InProgress = 1,
  ProviderReviewed = 2,
  SubmittedToGemini = 3,
  InValidation = 4,
  Verified = 5,
}
